import Box from 'components/Box';
import Text from 'components/Text';
import styled from 'styled-components';

interface SummaryItemProps {
  label: string;
  value: string;
  icon?: React.ReactNode;
  bgColor?: string;
}

const SummaryItem = ({ label, value, icon, bgColor }: SummaryItemProps) => {
  return (
    <ContainerStyled>
      <Box display='flex' alignItems='center' gap='3'>
        <IconBox style={{ backgroundColor: bgColor }}>{icon}</IconBox>
        <Text variant='H8' style={{ fontWeight: 500 }}>
          {label}
        </Text>
      </Box>
      <Text variant='H9'>{value}</Text>
    </ContainerStyled>
  );
};

export default SummaryItem;

const ContainerStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
`;

const IconBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 100px;
`;
